import React, {Component} from "react";
import AdobeAnalyticsProvider, {AdobeAnalyticsContext} from "../../context/AdobeAnalyticsContext";
import {Anywhere as AnywhereComponent} from "../../components/Anywhere/Anywhere";
import {UserContextData} from "../../context/UserContext";

interface Props {
    locale: string;
    userContext: UserContextData;
}

interface State {
    showModal: boolean;
}

export default class Anywhere extends Component<Props, State> {
    static contextType = AdobeAnalyticsContext;
    context!: React.ContextType<typeof AdobeAnalyticsContext>;

    state: State = {
        showModal: false,
    };

    componentDidMount() {
        this.context.track("pageevent", {
            pageName: "main",
            siteSection: "cloud available",
            language: AdobeAnalyticsProvider.getLocaleLanguage(this.props.locale),
            country: AdobeAnalyticsProvider.getLocaleCountry(this.props.locale)
        });

        this.recordPageVisit();
    }

    componentWillUnmount() {
        document.body.classList.remove('overflow-hidden');
    }

    render(): JSX.Element {
        return (
            <AnywhereComponent
                showAllGames={this.state.showModal}
                onShowAllGames={this.showModal}
                onHideAllGames={this.closeModal}
            />
        );
    }

    recordPageVisit = (): void => {
        localStorage.setItem("anywhereVisit", new Date().toISOString());
    };

    static checkPreviousPageVisit = (): boolean => {
        return !!localStorage.getItem("anywhereVisit");
    };

    showModal = () => {
        this.context.track("clickevent", {
            location: "page",
            category: "interaction",
            action: "view all games",
        });

        this.setState({showModal: true});
        document.body.classList.add('overflow-hidden');
    };

    closeModal = () => {
        this.setState({showModal: false});
        document.body.classList.remove('overflow-hidden');
    };
}